var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"constructor-button",class:{'constructor-button_active':_vm.active},on:{"mousedown":_vm.activate,"mouseup":_vm.deactivate,"mouseleave":_vm.deactivate,"click":_vm.$listeners.click}},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }